import React from 'react';
import Diaporama from '../components/Diaporama';
import ProchainHoraire from '../components/ProchainHoraire';
import Footer from '../components/Footer';
import '../styles/AppAgt.css';
import '../styles/PresentationHomogene.css';
import Benevoles from './Presentation/Benevoles';
import Detage from './Presentation/Detage';
import Gare from './Presentation/Gare';
import Petage from './Presentation/Petage';
import Rdc from './Presentation/Rdc';
import HistoriqueGare from './Presentation/HistoriqueGare';

const Accueil = () => {
    return (
        <div className='AppAgt'>
            <Diaporama />
            
            <ProchainHoraire />
            
            <div className='PresentationItems'>
                <Gare />
                <Rdc />
                <Petage />
                <Detage />

            </div>

            {/* Contenu de la page Presentation intégré */}
            <div className='Presentation'>
                <div className='PresentationItems'>
                    <HistoriqueGare />
                        <Benevoles />
                </div>
                

            </div>

            <Footer />  
        </div>
    );
};

export default Accueil;